


































































































































































































import LazyHydrate from 'vue-lazy-hydration';
import {
  SfLoader,
  SfTabs,
  SfProductCard,
  SfPagination,
  SfSelect,
  SfLink,
  SfAddToCart,
  SfButton
} from '@storefront-ui/vue';
import {
  computed,
  defineComponent,
  onMounted,
  useRouter,
  useRoute,
  useContext,
  ref,
  watch
} from '@nuxtjs/composition-api';
import productGetters from '~/modules/catalog/product/getters/productGetters';
import type { Product } from '~/modules/catalog/product/types';
import { useWishlist } from '~/modules/wishlist/composables/useWishlist';
import wishlistGetters from '~/modules/wishlist/getters/wishlistGetters';
import { useCart } from '~/modules/checkout/composables/useCart';
import { useWishlistStore } from '~/modules/wishlist/store/wishlistStore';
import EmptyWishlist from '~/modules/wishlist/components/EmptyWishlist.vue';
import { ProductTypeEnum } from '~/modules/catalog/product/enums/ProductTypeEnum';
import { useUiHelpers, useImage, useProduct } from '~/composables';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import { useUiNotification } from '~/composables';
import shareWishlistFormPopup from "~/components/czar/shareWishlistFormPopup/shareWishlistFormPopup.vue"

export default defineComponent({
  name: 'MyWishlist',
  components: {
    SfLoader,
    SfTabs,
    SfProductCard,
    SfPagination,
    SfSelect,
    EmptyWishlist,
    LazyHydrate,
    SfLink,
    SfAddToCart,
    SfButton,
    shareWishlistFormPopup
  },
  setup() {
    const {
      load,
      loading,
      removeItem,
      afterAddingWishlistItemToCart,
    } = useWishlist();
    const route = useRoute();
    const { localeRoute, $config, app: { i18n } } = useContext();
    const { getProductPath } = useProduct();
    const { query: { page, itemsPerPage },} = route.value;
    const router = useRouter();
    const th = useUiHelpers();
    const { addItem, addItem: addItemToCartBase, error: cartError, isInCart, loading: isCartLoading, canAddToCart, addedtocart_id: addedtocart_id } = useCart();
    const wishlistStore = useWishlistStore();
    const sharing_code = ref('')
    const { send: sendNotification } = useUiNotification();
    sharing_code.value = wishlistStore.wishlist?.sharing_code || '';
    watch(
      () => wishlistStore.wishlist,
      (newWishlist) => {
        if (newWishlist?.sharing_code) {
          sharing_code.value = newWishlist.sharing_code
        }
      },
      { immediate: true }
    )
    const products = computed(() => wishlistGetters.getProducts(wishlistStore.wishlist));
    const pagination = computed(() => wishlistGetters.getPagination(wishlistStore.wishlist));
    const itemComments = computed(() =>
      products.value
        .filter(product => !!product.description?.trim()) // only products with comment
        .map(product => ({
          item_id: Number(product.id),
          comment: product.description.trim()
        }))
    )
    const qty = ref([]);
    const addItemToCart = async ({ product, quantity }: { product: Product, quantity: number }) => {
      // eslint-disable-next-line no-underscore-dangle
      const productType = product.__typename;

      switch (productType) {
        case ProductTypeEnum.SIMPLE_PRODUCT:
          await addItemToCartBase({
            product,
            quantity,
          });
          afterAddingWishlistItemToCart({
            product,
            cartError: cartError.value.addItem,
          });
          break;
        case ProductTypeEnum.CONFIGURABLE_PRODUCT:
        case ProductTypeEnum.BUNDLE_PRODUCT:
        case ProductTypeEnum.GROUPED_PRODUCT:
          await router.push(localeRoute(getProductPath(product)));
          break;
        default:
          throw new Error(
            `Product Type ${productType} not supported in add to cart yet`,
          );
      }
    };

    const canShowAddTocart = (discontinued,stock_status) => {
     if(discontinued != 1 && stock_status == 'IN_STOCK')
     {
      return false;
     }
     return false;
    };

    const removeItemFromWishlist = async (product: Product) => {
      await removeItem({ product });
    };

    const { getMagentoImage, imageSizes } = useImage();

    onMounted(async () => {
      await load({
        searchParams: {
          currentPage: page ? Number.parseInt(page.toString(), 10) : 1,
          pageSize: itemsPerPage ? Number.parseInt(itemsPerPage.toString(), 10) : 10,
        },
      });
    });

    const addToCart = (product, qty) => {
      if (!qty) {
        qty = 1;
      }
      // @ts-ignore
      addItem({ product, quantity: parseInt(qty) });
    };

    const limit_title = (title) => {
      var count = 30;
      title = title.slice(0, count) + (title.length > count ? "..." : "");      
      return title;
    }

    const pageMeta = {
      "meta_title": null,
      "meta_description": null,
      "meta_keywords": null,
      "name": "Midwest Photo My Wish List",
    };

    const copyToClipboard = () => {
      if (process.client) {
        const currentUrl = ref($config.storecofigurl + '/wishlist/shared/' + sharing_code.value);
        navigator.clipboard.writeText(currentUrl.value).then(() => {
          addCopiedNotification();
        }).catch((err) => {
          console.error('Failed to copy: ', err)
        })
      }
    }

    const addCopiedNotification = () => {
      sendNotification({
        id: Symbol('text_copied'),
        type: 'success',
        icon: 'check',
        persist: false,
        message: i18n.t("Link Copied!") as string,
      });
    }

    const showPopup = ref(false);

    const openPopup = () => {
      if (window?.scroll && window?.innerWidth <= 1023) {
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
      }
      showPopup.value = true
    }

    return {
      addItemToCart,
      removeItemFromWishlist,
      isInCart,
      canShowAddTocart,
      isCartLoading,
      loading,
      pagination,
      productGetters,
      products,
      th,
      getMagentoImage,
      imageSizes,
      getProductPath,
      canAddToCart,
      qty,
      addToCart,
      addItem,
      limit_title,
      addedtocart_id,
      pageMeta,
      sharing_code,
      copyToClipboard,
      openPopup,
      showPopup,
      itemComments
    };
  },
  head() {
    return getMetaInfo(this.pageMeta);
  },
});
